import { Injectable } from '@angular/core';
import {HttpInterceptor,HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse,HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import {LogserviceService} from '../logservice/logservice.service';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Cache-Control': 'private, max-age=1200'
  })
};

@Injectable({
  providedIn: 'root'
})
export class AttachmentsService {
 
  constructor(private httpClient:HttpClient ,private logService:LogserviceService) { }
  httpHeaders = new HttpHeaders();

  backendUrl = environment.apiURL;



  
  
  getAttachments(payload){
    return this.httpClient.post(this.backendUrl+'gquery', payload, httpOptions);
  }
  entityCreate(payload:any):Observable<any> {
    return this.httpClient.post(this.backendUrl+'page/entity/create', payload, httpOptions);
  }
 

 
}
